/**
 * Covert a blog to a file
 *
 * A File is a Blob with additional properties attached to the object.
 */
export const blobToFile = (blob: Blob, fileName: string): File => {
  // @ts-ignore - Forcibly set lastModifiedDate
  blob.lastModifiedDate = new Date();
  // @ts-ignore - Forcibly set name
  blob.name = fileName;

  // Cast the Blob to a File
  return <File>blob;
};
